import { Input } from "antd";
import { useState } from "react";
import { BiSearch } from "react-icons/bi";
import { useDispatch } from "react-redux";

export default function CrmSearch({ handleSearch }) {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");

  const onSearchChange = (e) => {
    setInputValue(e.target.value);
  };
  const onSearch = () => {
      handleSearch(inputValue)
  };
  return (
    <Input
      className='md:w-[250px] !flex p-0 pr-3 w-[220px] common-search-input'
      placeholder='Search'
      onChange={onSearchChange}
      onPressEnter={onSearch}
      suffix={<BiSearch className='text-gray-400 cursor-pointer' onClick={onSearch} />}
    />
  );
}
